<template>
  <modal name="add-rate" height="auto" width="390px" :scrollable="true" :shiftY="0.2" @closed="close" :clickToClose="!loading">
    <div class="close" v-if="!loading">
      <img class="hover_btn" src="../../assets/icons/close.svg" @click="$modal.hide('add-rate')"  alt="">
    </div>
    <div class="modal-form">
      <transition name="fade" mode="out-in">
        <div v-if="!loading">
          <h4 class="title">Оцените заказ</h4>
          <div class="rate-group">
            <app-rate v-model="rate[item.id]" name="rate"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      data-vv-as="" v-for="(item, key) in options" :key="'rate'+key">{{item.value}}</app-rate>
            <span class="text-danger text-sm" v-if="errors.has('rate')">Проставте все оценки</span>
          </div>
          <h4>Комментарий</h4>
          <div class="input-block">
            <textarea
                type="text"
                v-model="comment"
                name="comment"
                v-validate="'required'"
                data-vv-validate-on="blur"
                data-vv-as="Комментарий"
            ></textarea>
            <span class="text-danger text-sm" >{{ errors.first('comment') }}</span>
          </div>
          <div class="btn">
            <button @click="save">Сохранить</button>
          </div>
        </div>
        <div class="progress-bar-container" v-if="loading">
          <app-loader/>
          <div style="margin-left: 15px">Публикуем ваш отзыв...</div>
        </div>
      </transition>

    </div>
  </modal>
</template>

<script>

import AppRate from "@/components/app-rate";
import AppLoader from "@/components/app-loader";
export default {
  name: "add-rate-modal",
  components: { AppLoader, AppRate },
  data: ()=> ({
    rate:[],
    comment: '',
    id: null,
    loading: false,
    options: []
  }),
  mounted() {
    if (localStorage.getItem('type') == 2) {
      // this.options = [
      //   'Наличие товара и ассортимент',
      //   'Коммерческие условия',
      //   'Скорость подтверждения заказа',
      //   'Качество и скорость доставки',
      //   'Работа менеджера'
      // ];
      this.$http.post('/get-question-type', {
        token: localStorage.getItem('token'),
        type: 2
      }).then(({data}) => {
        this.options = data.question
      }).catch((error) => {
        console.log(error)
      })
    } else {
      this.$http.post('/get-question-type', {
        token: localStorage.getItem('token'),
        type: 1
      }).then(({data}) => {
        this.options = data.question
      }).catch((error) => {
        console.log(error)
      })

      // this.options = [
      //   'Финансовая дисциплина',
      //   'Скорость согласования заказа',
      //   'Соблюдение РРЦ',
      //   'Работа менеджера',
      //   'Активность в продажах товара'
      // ];
    }
  },
  methods: {
    open(id = null){
      if(id == null) return console.error('[add-rate-modal:open] prop id required!')
      this.id = id;
      this.$modal.show('add-rate');
    },
    close(){
      this.id = this.comment = null;
      this.rate = []
    },
    save() {
      this.$validator.validateAll().then(success => {
        if(success) {
          this.loading = true;
          this.$http.post('/create-vote-company', {
            token: localStorage.getItem('token'),
            review: this.comment,
            id: this.id,
            rate: this.rate
          }).then(({data}) => {
            if (data.success) {
              this.$emit('saved', this.id)
              this.close()
              this.$modal.hide('add-rate')
            }else if(data.vote){
              this.$toast.error('Отзыв уже оставлен');
              this.close()
              this.$modal.hide('add-rate')
            }
          })
            .catch((error) => {
              console.log(error)
            })
            .finally(()=> {this.loading = false})
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">


.progress-bar-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn{
  width: 100%;
  padding: 0;
  button{
    width: 100%;
    height: 50px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    background: #2CB181;
    border-radius: 4px;
    border: none;
  }
}
.modal-form {
  padding: 30px;
}
.input-block {
  margin-bottom: 15px;
}
h4{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin: 0 0 5px 1px;

  &.title{
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;
  }

  &.add{
    display: flex;
    justify-content: space-between;
    a{
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      text-decoration-line: underline;
      color: #7A818F;
    }
  }
}
.rate-group{
  margin-bottom: 24px;
}
textarea{
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding-left: 10px;
  width: 100%;
  height: 90px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  &.about{
    height: 117px;
  }
  &:disabled{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    background: #EEF0F3;
  }
}
</style>
